import { Members } from '../../../core/model/member.model';
import { Role } from '../../../core/constants';

export interface MembersSelectDialogConfig {
    members?: Members | null;
    excludeUserIds?: string[] | null;
    excludeRoles?: Role[] | null;
    disableMultiSelection?: boolean | null;
}
